function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { SignSlider } from "./SignSlider";
import styles from "./MobileSign.module.scss";
import { SignatureWithProgress } from "./SignatureWithProgress";
import { Typography, useIntentBehavior } from 'seagull';
import cn from 'classnames';
import { relationshipModel } from "../../../../models";
export function MobileSign(_ref) {
  let {
    relationship,
    disabled = false,
    intent,
    onSign
  } = _ref;
  const [percent, setPercent] = useState(0);
  const {
    getDisabled
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const isDisabled = disabledFromIntent || disabled;
  const typographyProps = isDisabled ? {
    skin: 'invertedStandard',
    className: styles.hint
  } : {
    className: cn(styles.hint, styles.enabled)
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, disabled || /*#__PURE__*/React.createElement(SignatureWithProgress, {
    percent: percent
  }, relationshipModel.buyerFullName(relationship)), /*#__PURE__*/React.createElement("div", {
    className: styles.slider
  }, /*#__PURE__*/React.createElement(SignSlider, {
    disabled: isDisabled,
    onChange: setPercent,
    onSign: onSign
  }), /*#__PURE__*/React.createElement(Typography, _extends({}, typographyProps, {
    style: {
      opacity: Math.max(1 - 6 * percent, 0)
    }
  }), relationship.isSample ? 'Approve test agreement' : 'Swipe to approve agreement')));
}